var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mfu-module"},[_c('ButtonGroup',[_c('Button',{on:{"click":function($event){return _vm.uploadFiles(true)}}},[_vm._v(_vm._s(_vm.def.Labels.UploadButton))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }